import { FC, memo, PropsWithChildren, useContext, useEffect } from "react";

import { useRouter } from "next/router";

import { isReviewApp } from "../../../common/constants/env";
import { useCurrentUserContext } from "../../../common/contexts/CurrentUserContext";
import { PageLoadingContext } from "../../../common/providers/PageLoadingProvider";

import { redirectToLogout } from "@/common/helpers/auth";
import { useLogRouteChangePageVisits, RouteType } from "@/common/hooks/amplitude/useLogRouteChangePageVisits";

const DonorRouteToMemoized: FC<PropsWithChildren> = ({ children }) => {
  const router = useRouter();
  useLogRouteChangePageVisits({ path: router.pathname, routeType: RouteType.DonorRoute });
  const { isAuthenticated, userIsLoading, connectedAsAdministrator } = useCurrentUserContext();
  const { setRedirectionLoading } = useContext(PageLoadingContext);
  if (router.isReady && !userIsLoading && !isAuthenticated) {
    if (isReviewApp) {
      void router.replace(`/review-app/login?donor=true&redirectionUrl=${encodeURIComponent(router.asPath)}`);
    } else {
      void redirectToLogout({ redirectionUrl: router.asPath, connectedAsAdministrator });
    }
  }

  useEffect(() => {
    setRedirectionLoading(false);
  }, [setRedirectionLoading]);

  return <>{children}</>;
};

export const DonorRoute = memo(DonorRouteToMemoized);
